var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24485 0.571442C3.97276 0.571442 1.32005 3.27384 1.32005 6.60722C1.32005 7.68272 1.59905 8.69001 2.08283 9.56428C2.08339 9.56712 2.08227 9.5711 2.08339 9.57281C2.19945 9.77176 2.32835 10.2129 2.32835 10.6415C2.32835 11.397 2.0739 11.8807 1.45787 12.5077C1.03156 12.942 0.691744 13.2848 0.584609 13.3928C0.561173 13.4166 0.568985 13.4286 0.608045 13.4286H7.24485C10.8891 13.4286 13.4286 10.1219 13.4286 7.0489C13.4286 3.9753 11.4198 2.32453 11.4198 2.32453L11.4187 2.3251C10.3479 1.24164 8.87309 0.571442 7.24485 0.571442Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24485 0.571442C3.97276 0.571442 1.32005 3.27384 1.32005 6.60722C1.32005 7.68272 1.59905 8.69001 2.08283 9.56428C2.08339 9.56712 2.08227 9.5711 2.08339 9.57281C2.19945 9.77176 2.32835 10.2129 2.32835 10.6415C2.32835 11.397 2.0739 11.8807 1.45787 12.5077C1.03156 12.942 0.691744 13.2848 0.584609 13.3928C0.561173 13.4166 0.568985 13.4286 0.608045 13.4286H7.24485C10.8891 13.4286 13.4286 10.1219 13.4286 7.0489C13.4286 3.9753 11.4198 2.32453 11.4198 2.32453L11.4187 2.3251C10.3479 1.24164 8.87309 0.571442 7.24485 0.571442",
    stroke: "#00A3E0",
    strokeWidth: 1.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNote);
export default __webpack_public_path__ + "static/media/open-note.e7df3e1ae4e80cb391ec2e82c06c22f5.svg";
export { ForwardRef as ReactComponent };